import { db, doc, updateDoc, setDoc, arrayUnion, getDoc } from "../firebaseConfig";

/**
 * Saves email addresses to AdminCollection sentEmailAddresses array
 * @param {Array} toEmails - Array of to email objects/strings
 * @param {Array} ccEmails - Array of cc email objects/strings  
 * @param {Array} bccEmails - Array of bcc email objects/strings
 */
export const saveEmailAddresses = async (toEmails = [], ccEmails = [], bccEmails = []) => {
  try {
    // Extract email addresses from all sources
    const allEmails = [];
    
    // Process all email arrays
    [toEmails, ccEmails, bccEmails].forEach(emailArray => {
      if (Array.isArray(emailArray)) {
        emailArray.forEach(email => {
          const emailAddress = typeof email === "object" ? email.email : email;
          if (emailAddress && emailAddress.trim()) {
            allEmails.push(emailAddress.trim());
          }
        });
      }
    });
    
    // Remove duplicates
    const uniqueEmails = [...new Set(allEmails)];
    
    // Only proceed if we have emails to save
    if (uniqueEmails.length === 0) {
      console.log("No emails to save");
      return;
    }
    
    console.log("Attempting to save email addresses:", uniqueEmails);
    
    const sentEmailAddressesRef = doc(db, "AdminCollection", "sentEmailAddresses");
    
    // Check if document exists first
    const docSnapshot = await getDoc(sentEmailAddressesRef);
    
    if (docSnapshot.exists()) {
      // Document exists, use arrayUnion to add new emails
      await updateDoc(sentEmailAddressesRef, {
        sentEmailAddresses: arrayUnion(...uniqueEmails)
      });
      console.log("✅ Email addresses updated:", uniqueEmails);
    } else {
      // Document doesn't exist, create it
      await setDoc(sentEmailAddressesRef, {
        sentEmailAddresses: uniqueEmails
      });
      console.log("✅ Email addresses document created with:", uniqueEmails);
    }
    
  } catch (error) {
    console.error("❌ Error saving email addresses:", error);
    console.error("Error code:", error.code);
    console.error("Error details:", error.message);
  }
};